import React from 'react';


export function DisclaimerHeader({ blockName, children, }) {
  const elementName = '__header';
  const bemClass = `${blockName}${elementName}`;
  return (
    <div className={ bemClass }>
      <div className={ `${bemClass}-shape` }>
        <h5 className={ `${bemClass}-text` }>
          { children }
        </h5>
      </div>
    </div>
  );
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/community_disclaimer/components/disclaimerHeader.js